import { render, staticRenderFns } from "./AcceptProjectInvitationToken.vue?vue&type=template&id=0534ec07"
import script from "./AcceptProjectInvitationToken.vue?vue&type=script&lang=ts"
export * from "./AcceptProjectInvitationToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports